/**
 * Navigation & Layout Icons
 *
 * Icons for menus, routing, page layouts, and navigation controls.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHouse as fadHouse,
  faRectangleList as fadRectangleList,
  faListCheck as fadListCheck,
  faLayerGroup as fadLayerGroup,
  faBoxes as fadBoxes,
  faBoxesStacked as fadBoxesStacked,
  faArrowRightFromBracket as fadArrowRightFromBracket,
  faBarsFilter as fadBarsFilter,
  faRoute as fadRoute,
  faGrid2 as fadGrid2,
  faSidebar as fadSidebar,
  faCalendar as fadCalendar,
  faShareFromSquare as fadShareFromSquare,
  faMapLocationDot as fadMapLocationDot,
  faCar as fadCar,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faGrid2 as fasGrid2,
  faShareFromSquare as fasShareFromSquare,
} from '@fortawesome/pro-solid-svg-icons';

export const loadNavigationIcons = () => {
  library.add(
    fadHouse,
    fadRectangleList,
    fadListCheck,
    fadLayerGroup,
    fadBoxes,
    fadBoxesStacked,
    fadArrowRightFromBracket,
    fadBarsFilter,
    fadRoute,
    fadGrid2,
    fadSidebar,
    fadCalendar,
    fadShareFromSquare,
    fasGrid2,
    fasShareFromSquare,
    fadMapLocationDot,
    fadCar,
  );
};
